const transcludeInjectDirectiveDefinition = () => ({
    scope: {
        slot: '@?transcludeInject',
        injectedItem: '=',
        injectedProperty: '@',
    },

    link($scope, $element, $attrs, controller, $transclude) {
        const injectedProperty = $scope.injectedProperty || 'item';

        if (!$transclude) {
            throw new Error('Cannot inject scope into a non-transcluded child.');
        }

        $transclude((clone, scope) => {
            scope[injectedProperty] = $scope.injectedItem;
            $element.empty();
            $element.append(clone);
        }, undefined, $scope.slot);
    },
});

module.exports = { transcludeInjectDirectiveDefinition };



// WEBPACK FOOTER //
// ./src/olycommon/transcludeinject/transclude-inject.directive.js